export const table_titles = [
	{ name: "", size: 5, order: "" },
	{ name: "Nombre", size: 15, order: "name" },
	{ name: "Ingrediente Activo", size: 10, order: "" },
	{ name: "Aptitud", size: 10, order: "" },
	{ name: "Densidad", size: 5, order: "" },
	{ name: "Categoría", size: 10, order: "" },
	{ name: "País", size: 5, order: "" },
	{ name: "Cliente", size: 10, order: "" },
	{ name: "Bodega", size: 10, order: "" },
	{ name: "Precio Unitario ($/Kg, L)", size: 10, order: "" },
	{ name: "Código", size: 5, order: "" },
	{ name: "Stock", size: 5, order: "" },
	{ name: "U.M.", size: 5, order: "" },
	{ name: "Conteo", size: 5, order: "" },
	{ name: "Acción", size: 5, order: "" },
];

export const filters = {
	customer_id: "",
	country_id: "1",
	unit_measurement: "",
	dealer_id: "",
	category_id: "",
	aptitud_id: "",
	chemical_id: "",
	is_generic: false,
};

export const customStyles = {
	menuPortal: (base) => ({
		...base,
		zIndex: 9999999,
	}),
	menu: (provided) => ({ ...provided, zIndex: 9999999 }),
};

export const unitMeasurementOptions = [
	{ value: "g", label: "Kg" },
	{ value: "cc", label: "L" },
	{ value: "u", label: "Un" },
];

export const base_product = {
	id: "",
	name: "",
	unit_measurement: "",
	dealer_id: "",
	country_id: "",
	chemical_id: "",
	active_ingredient: "",
	category_id: "",
	aptitud_id: "",
	density: "",
	only_return: "0",
	reingreso: "",
	color_tag: "",

	url_tag: "",
	url_data_sheet: "",
	url_safety_sheet: "",
	url_brochure: "",

	cas: "",
	formula: "",
	unique_code: "",
	is_new: "",
	code_sag: "",
	max_applications: "",

	weights: [],
};
